






































import Vue from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import GameBtn from '@/components/GameBtn.vue'

export default Vue.extend({
  name: 'App',

  components: {
    GameBtn
  },

  data: () => ({
    //
  }),
  computed: {
    ...mapState(['current']),
    ...mapGetters(['activePlayerCharacters', 'activeNonPlayerCharacters']),
    disabled () {
      return !(
        this.current?.characters?.length || this.current?.goals?.length || this.current?.places?.length
      )
    },
    footerText () {
      return `Git Hash: '${process?.env?.VUE_APP_GIT_HASH ?? 'N/A'}'`
    }
  },
  methods: {
    ...mapActions(['showRemoteStorageWidget'])
  },
  watch: {
    $route: {
      handler (to, from) {
        let title = to.meta.title || 'GM Emulator'
        if (this?.current?.game) {
          title += ' | ' + this.current.game.name
        }
        document.title = title
      },
      immediate: true
    }
  },
  mounted () {
    this.showRemoteStorageWidget()
  }
})
